import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, PropType } from 'vue'
import { AccountStatusType } from '@/plugins/nicotto'
import InputSelect from "@/components/ui/InputSelect.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'InputUserStatus',
  props: {
  required: { type: Boolean, default: false },
  modelValue: { type: String as PropType<AccountStatusType|null>, default: null }
},
  emits: ["update:modelValue"],
  setup(__props, { emit }: { emit: ({
  (event: 'update:modelValue', status: AccountStatusType|null): void,
}), expose: any, slots: any, attrs: any }) {

const props = __props



// eslint-disable-next-line func-call-spacing


const userStatus = computed({
  get: () => props.modelValue || '',
  set: (val: AccountStatusType|null|'') => (emit('update:modelValue', val || null))
})

const options = [
  { name:'有効', value:'enabled' },
  { name:'無効', value:'disabled' },
  { name:'未承認', value:'notAccepted' }
]

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(InputSelect, {
    modelValue: _unref(userStatus),
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(userStatus) ? (userStatus).value = $event : null)),
    options: options,
    result: "value",
    required: props.required,
    label: "ユーザのステータス",
    title: "ユーザのステータス"
  }, null, 8, ["modelValue", "required"]))
}
}

})